import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import {
  assert_array_includes,
  assert_array_not_includes,
  assert_string_not_empty,
  assert_string_object_id,
  assert_type_boolean,
  assert_type_enum,
} from '@shared/asserts/utils_asserts';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { MAP_OF_MAP__fields_store, TYPE_FIELDS_ONLY } from '@shared/types/types';
import { DTO__image_asset } from '../+image/image_asset_base/DTO__image_asset';
import { ENUM__dto_class_name } from '../../serialization/ENUM__dto_class_name';
import { MAP__serializable } from '../_base/MAP__serializable';
import { ENUM__generation_status } from './_enums/ENUM__generation_status';
import { DTO__generation_tool } from './DTO__generation_tool';
import { FIELD__base } from './graph_invoke/_fields/_base/FIELD__base';
import { FIELD_PRIMITIVE__int } from './graph_invoke/_fields/_primitives/number/FIELD_PRIMITIVE__int';
import { ENUM__image_asset_category } from './graph_invoke/_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from './graph_invoke/_fields/image/FIELD__image_asset';

//we use  DTO__entity_with_grid2d here to use grid2d possible features on client
export class DTO__generation extends DTO__entity_with_grid2d {
  /*
   * STATIC FIELDS
   */

  static _class_name_static: string = ENUM__dto_class_name.GENERATION;

  /*
   *
   * DB FIELDS
   *
   */

  user_task_id!: string;

  previous_generation_id!: string;

  status!: ENUM__generation_status;

  started_at!: number;
  ended_at!: number;

  //todo: rename user_spent_time
  duration_adjusting!: number;

  graph_field_consumer!: FIELD__base;

  tool!: DTO__generation_tool;

  is_visible!: boolean;

  //key1 - node family, key2 - field role
  fields_store!: MAP_OF_MAP__fields_store;

  bundle_id__used!: string;

  /*
   * METHODS
   */

  constructor() {
    super();

    this.tool = DTO__generation_tool.CREATE_STUB();
    this.graph_field_consumer = FIELD_PRIMITIVE__int.CREATE_STUB();

    this.fields_store = new MAP__serializable();
  }

  is_finished(): boolean {
    return CONSTANTS__shared.GENERATION_STATUS_FINISHED.includes(this.status);
  }

  get is_in_progress() {
    return this.status == ENUM__generation_status.IN_PROGRESS;
  }

  is_locked() {
    return this.status == ENUM__generation_status.LOCKED;
  }

  image_can_be_consumed(image: DTO__image_asset) {
    if (image.is_stub()) return false;
    if (this.graph_field_consumer.is_stub()) return false;
    if (!(this.graph_field_consumer instanceof FIELD__image_asset)) return false;
    if (image.category == ENUM__image_asset_category.ANY) return true;
    if (this.graph_field_consumer.category == ENUM__image_asset_category.ANY) return true;

    return this.graph_field_consumer.category == image.category;
  }

  /*
   * ASSERTS
   */
  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_string_object_id(this.user_task_id);

    assert_string_not_empty(this.previous_generation_id);

    assert_type_enum(this.status, ENUM__generation_status);

    assert_type_boolean(this.is_visible);
  }

  assert_statuses(accepted_statuses: string[]) {
    assert_array_includes(accepted_statuses, this.status, {
      context: 'status',
      assert_type: ENUM__error_type.GENERATION_WRONG_STATUS,
      status: this.status,
      generation_id: this._id,
    });
  }

  assert_not_statuses(denied_statuses: string[]) {
    assert_array_not_includes(denied_statuses, this.status, {
      assert_type: ENUM__error_type.GENERATION_WRONG_STATUS,
      status: this.status,
      generation_id: this._id,
    });
  }
}

export interface INTERFACE__generation extends Omit<
  TYPE_FIELDS_ONLY<DTO__generation>,
  '_id' | 'grid2d_possible_features' | '_class_name_instance' | 'fields_ignored_in_hash' | '_is_stub'
> {}
